<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <bookmarks />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <NotificacionFaltas v-if="isCeo" />

      <div class="mr-1 container-attendace">
        <feather-icon
          @click="goToAttendance"
          id="icon-attendance"
          size="20"
          icon="CalendarIcon"
          class="text-primary"
        ></feather-icon>
        <b-tooltip
          target="icon-attendance"
          variant="primary"
          triggers="hover"
          >{{ $t("my attendance") | capitalize }}</b-tooltip
        >
      </div>
      <locale />
      <dark-Toggler class="d-none d-lg-block" />
      <search-bar />
      <!-- <cart-dropdown /> -->
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav } from "bootstrap-vue";
import Bookmarks from "./components/Bookmarks.vue";
import Locale from "./components/Locale.vue";
import SearchBar from "./components/SearchBar.vue";
import DarkToggler from "./components/DarkToggler.vue";
import CartDropdown from "./components/CartDropdown.vue";
import NotificationDropdown from "./components/NotificationDropdown.vue";
import UserDropdown from "./components/UserDropdown.vue";
import NotificacionFaltas from "@/@core/layouts/components/app-navbar/components/NotificacionFaltas.vue";
export default {
  components: {
    BLink,
    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
    NotificacionFaltas,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

  methods: {
    goToAttendance() {
      this.$router.push({ name: "my-attendance-attendance" });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-attendace {
  width: 20px;
  height: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  position: relative;
}
.calendar-attendace {
  cursor: pointer;
  position: absolute;
  animation: jump 1s infinite;
}

@keyframes jump {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(1px);
  }
}
</style>